export const CityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 9L12 2L21 9V21H3V9Z"></path>
      <path d="M9 22V12H15V22"></path>
    </svg>
  );
};
